import React, { memo, useCallback, useEffect, useState } from 'react';

import { Box, Checkbox, ListItemText, Menu, MenuItem } from '@mui/material';
import { AiFillPlusCircle } from '@react-icons/all-files/ai/AiFillPlusCircle';
import debounce from 'lodash.debounce';

import {
  MAIN_BENCHMARKS,
  BENCHMARKS_SELECT,
} from '@mais-retorno-front/libs/util-benchmark-constants';
import { Chip } from '../../styles';
import { hasSelected } from '../../helper';
import { IBenchmarkProps } from './interface';

export const Benchmark = memo<IBenchmarkProps>(
  ({ defaultSelectedBenchmarks = [], onSelectedBenchmarksChange }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedBenchmarks, setSelectedBenchmarks] = useState(
      defaultSelectedBenchmarks
    );

    useEffect(() => {
      if (defaultSelectedBenchmarks && defaultSelectedBenchmarks?.length) {
        setSelectedBenchmarks(defaultSelectedBenchmarks);
      }
    }, [defaultSelectedBenchmarks]);

    const delayed = useCallback(debounce(onSelectedBenchmarksChange, 600), [
      onSelectedBenchmarksChange,
    ]);

    useEffect(() => {
      return delayed.cancel;
    }, [delayed]);

    const onSelectBenchmark = (benchmark: string) => {
      const exist = hasSelected(benchmark, selectedBenchmarks);

      if (exist) {
        setSelectedBenchmarks([...selectedBenchmarks, benchmark]);

        delayed([...selectedBenchmarks, benchmark]);
      } else {
        const filtered = selectedBenchmarks.filter((b) => b !== benchmark);

        setSelectedBenchmarks(filtered);
        delayed(filtered);
      }
    };

    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <div data-tour="profit-comparison-benchmarks-button">
        {MAIN_BENCHMARKS.map(({ label, value }) => (
          <Chip
            key={value}
            color="primary"
            label={label}
            clickable
            variant={
              hasSelected(value, selectedBenchmarks) ? 'outlined' : 'filled'
            }
            onClick={() => onSelectBenchmark(value)}
          />
        ))}

        <Chip
          label="MAIS INDICADORES"
          data-testid="benchmark-menu-button"
          aria-controls="benchmark-menu"
          aria-haspopup="true"
          color="primary"
          variant="outlined"
          clickable
          deleteIcon={<AiFillPlusCircle height={19} color="#0f132a" />}
          onDelete={handleClick}
          onClick={handleClick}
        />

        <Menu
          id="benchmark-menu"
          data-testid="benchmark-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {BENCHMARKS_SELECT.map(({ value, label }) => (
            <Box key={`benchmark-${value}`}>
              <MenuItem
                sx={{ padding: '3px 10px' }}
                value={value}
                onClick={() => onSelectBenchmark(value)}
              >
                <Checkbox checked={!hasSelected(value, selectedBenchmarks)} />
                <ListItemText primary={label} />
              </MenuItem>
            </Box>
          ))}
        </Menu>
      </div>
    );
  }
);
